import Vue from 'vue';
import InfiniteLoading from 'vue-infinite-loading';
import InfiniteLoadingError from '@/components/molecules/InfiniteLoadingError.vue';

Vue.use(InfiniteLoading, {
  /**
   * @see https://peachscript.github.io/vue-infinite-loading/guide/configure-plugin-opts.html#props-settings
   * @see https://peachscript.github.io/vue-infinite-loading/api/#options
   */
  props: {
    spinner: 'default', // spiral | circles | bubbles | waveDots,
  },
  slots: {
    noResults: 'データがありません',
    noMore: 'すべてのデータを読み込みました',
    error: InfiniteLoadingError,
  },
});
